/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_EnrichmentInputs */

const en_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrichment`)
};

const zh_hans1_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据补全`)
};

const pt_br2_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enriquecimento`)
};

const es_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enriquecimiento`)
};

const fr_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrichissement`)
};

const de_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenanreicherung`)
};

const ru_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обогащение данных`)
};

const it_category_enrichment = /** @type {(inputs: Category_EnrichmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arricchimento`)
};

/**
* | output |
* | --- |
* | "Enrichment" |
*
* @param {Category_EnrichmentInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_enrichment = /** @type {((inputs?: Category_EnrichmentInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_EnrichmentInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_enrichment(inputs)
	if (locale === "pt-BR") return pt_br2_category_enrichment(inputs)
	if (locale === "es") return es_category_enrichment(inputs)
	if (locale === "fr") return fr_category_enrichment(inputs)
	if (locale === "de") return de_category_enrichment(inputs)
	if (locale === "ru") return ru_category_enrichment(inputs)
	if (locale === "it") return it_category_enrichment(inputs)
	return en_category_enrichment(inputs)
});